import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LOGO from '../assets/image/logo_visual.webp';
import { LanguageDropdown } from '../locale/language-dropdown';
import { ThemeSwitcher } from '../theme/theme-switcher';

interface HeaderProps {
}

export function Header({ }: HeaderProps) {
    const { t } = useTranslation();

    return (
        <header className="w-full px-6 pt-6">
            <div className="mx-auto flex w-full max-w-5xl flex-wrap items-center gap-3">
                <Link to="/" className="flex min-w-0 items-center gap-3 text-white">
                    <img src={LOGO} alt={t('global.brand.txtLogoAlt')} className="h-9 w-9" />
                    <span className="truncate text-lg font-semibold tracking-tight">{t('global.brand.txtName')}</span>
                </Link>
                <div className="ml-auto flex items-center gap-2">
                    <ThemeSwitcher />
                    <LanguageDropdown />
                </div>
            </div>
        </header>
    );
}
